import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import common from 'src/js/modules/common';
import constants from '../constants';
import helpers from '../helpers';
import verifiers from '../verifiers';
import BasicFieldControls from './basic-field-controls';
import OptionsFieldControls from './options-field-controls';
import TimeFieldControls from './time-field-controls';
import FileFieldControls from './file-field-controls';

const {
  components: { ModalWithPanels },
} = common;
const {
  common: { MODAL_WIDTH, MODAL_HEIGHT, MODAL_HEIGHT_WITH_TABS },
  fieldControlCategories,
} = constants;

function ContactFormEditFieldDialog({
  control,
  field,
  fieldTypes,
  fieldControlCategory,
  type,
  placeholders,
  modalPosition,
  isNewField,
  onChangeRequiredFieldControl,
  onSubmit,
  onCancel,
  onModalOverlayClick,
  onModalPositionUpdate,
}) {
  const enableBuilder = verifiers.isBuilderEnabled();
  const modalHeight = enableBuilder ? MODAL_HEIGHT_WITH_TABS : MODAL_HEIGHT;

  const fieldTypeOptions = helpers.getFieldTypeOptions(fieldTypes);

  const fieldTitle = isNewField
    ? field.title
    : Object.values(fieldTypeOptions)
        .flat()
        .find((el) => el.type === type).label;
  const title = isNewField
    ? `${i18next.t('New Item')} - ${fieldTitle || i18next.t('Short text')}`
    : `${i18next.t('Edit Item')} - ${fieldTitle || i18next.t('Short text')}`;

  return (
    <ModalWithPanels
      width={MODAL_WIDTH}
      height={modalHeight}
      offsetX={modalPosition.offsetX}
      offsetY={modalPosition.offsetY}
      captions={{
        title,
        submitButton: i18next.t('Submit'),
        cancelButton: i18next.t('Cancel'),
      }}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onOverlayClick={onModalOverlayClick}
      onDragEnd={onModalPositionUpdate}
      onPressEsc={onCancel}
    >
      {fieldControlCategory === fieldControlCategories.BASIC && (
        <BasicFieldControls
          control={control}
          placeholders={placeholders}
          onChangeRequiredFieldControl={onChangeRequiredFieldControl}
        />
      )}
      {fieldControlCategory === fieldControlCategories.OPTIONS && (
        <OptionsFieldControls
          control={control}
          type={type}
          placeholders={placeholders}
          minOptionsCount={helpers.getMinCountOfOptionsFieldControl(type, fieldTypes)}
          onChangeRequiredFieldControl={onChangeRequiredFieldControl}
        />
      )}
      {fieldControlCategory === fieldControlCategories.TIME && (
        <TimeFieldControls
          control={control}
          placeholders={placeholders}
          onChangeRequiredFieldControl={onChangeRequiredFieldControl}
        />
      )}
      {fieldControlCategory === fieldControlCategories.FILE && (
        <FileFieldControls
          control={control}
          placeholders={placeholders}
          onChangeRequiredFieldControl={onChangeRequiredFieldControl}
        />
      )}
    </ModalWithPanels>
  );
}

ContactFormEditFieldDialog.propTypes = {
  control: PropTypes.shape({}).isRequired,
  field: PropTypes.shape().isRequired,
  fieldTypes: PropTypes.shape().isRequired,
  fieldControlCategory: PropTypes.oneOf(Object.values(fieldControlCategories)).isRequired,
  type: PropTypes.string.isRequired,
  placeholders: PropTypes.shape({}).isRequired,
  modalPosition: PropTypes.shape({
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
  }).isRequired,
  isNewField: PropTypes.bool.isRequired,
  onChangeRequiredFieldControl: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onModalOverlayClick: PropTypes.func.isRequired,
  onModalPositionUpdate: PropTypes.func.isRequired,
};

export default ContactFormEditFieldDialog;
